export default {
  /** 产品出库-获取分页查询列表 */
  LIST_OUTSTOCK_BY_PAGE: '/produce/pdProductOutboundDetail/queryPage',
  /** 产品出库-批量导入 */
  LIST_OUTSTOCK_IMPORT: '/produce/pdProductOutboundDetail/importExcel',
  /** 产品出库-批量导出 */
  LIST_OUTSTOCK_EXPORT: '/produce/pdProductOutboundDetail/exportExcel',
  /** 产品出库-批量删除 */
  LIST_OUTSTOCK_DELETE: '/produce/pdProductOutboundDetail/deleteDetails',
};
